"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirebaseUserTokenId = exports.useAnalytics = exports.createAnalyticsHook = exports.AnalyticsProvider = exports.AnalyticsContext = void 0;
const react_1 = __importDefault(require("react"));
const config_1 = require("../../../web/config");
const constants_1 = require("../../constants/constants");
const store_1 = require("../../store");
const mixpanel = require('mixpanel-browser');
exports.AnalyticsContext = react_1.default.createContext({});
if (process.env.NODE_ENV !== 'production') {
    exports.AnalyticsContext.displayName = 'AnalyticsContext';
}
const AnalyticsProvider = ({ children }) => {
    // configure all the necessary analytics tools here (firebase, etc)
    mixpanel.init(config_1.MIXPANEL_TOKEN);
    // store in this object all the necessary objects that we will interact down in the tree
    const analyticsObjects = {
        firebase: null,
        dispatch: (0, store_1.useAppDispatch)(),
    };
    return react_1.default.createElement(exports.AnalyticsContext.Provider, { value: analyticsObjects }, children);
};
exports.AnalyticsProvider = AnalyticsProvider;
const platform = 'web';
const version = `web_${constants_1.APP_VERSION}`;
// TODO: Marked as suspicious because of the usage and so on -> check later or remove :: Dominik
// export const logEventUtil = (name: string, email: string, id: string) => {
//     if (email && id && name !== '') {
//         try {
//             const event = name.replace(/\W/g, '').substring(0, 39);
//             mixpanel.track(event, {
//                 uuid: id,
//                 distinct_id: id,
//                 email,
//                 platform,
//                 version,
//             });
//         } catch (error) {
//             // so yeah... where to send the error?
//         }
//     }
// };
// HERE I'm creating the hook, the hook returns three functions, can be more
function createAnalyticsHook() {
    return function useAnalytics() {
        const { email, id } = (0, store_1.useAppSelector)((state) => {
            return {
                email: state.auth.email,
                id: state.auth.id,
            };
        });
        const logEvent = (name) => {
            if (email && id && name !== '') {
                try {
                    const event = name.replace(/\W/g, '').substring(0, 39);
                    const properties = {
                        uuid: id,
                        distinct_id: id,
                        email,
                        platform,
                        version,
                    };
                    mixpanel.track(event, [properties]);
                }
                catch (error) {
                    // so yeah... where to send the error?
                }
            }
        };
        const logEventWithExtraProperties = (name, extraProperties) => {
            if (email && id) {
                try {
                    const event = name.replace(/\W/g, '').substring(0, 39);
                    const eventProperties = {
                        uuid: id,
                        distinct_id: id,
                        email,
                        platform,
                        version,
                        ...extraProperties,
                    };
                    mixpanel.track(event, eventProperties);
                }
                catch (error) {
                    // so yeah... where to send the error?
                }
            }
        };
        const trackScreenView = (name, screen_name) => {
            if (email && id) {
                try {
                    const screen = name.replace(/\W/g, '').substring(0, 39);
                    mixpanel.track(screen, {
                        uuid: id,
                        distinct_id: id,
                        email,
                        platform,
                        version,
                        screen_name,
                    });
                }
                catch (error) {
                    // so yeah... where to send the error?
                }
            }
        };
        const setUser = () => {
            if (id) {
                mixpanel.identify(id);
            }
        };
        return { logEvent, logEventWithExtraProperties, trackScreenView, setUser };
    };
}
exports.createAnalyticsHook = createAnalyticsHook;
exports.useAnalytics = createAnalyticsHook();
// get firebase user token id
const getFirebaseUserTokenId = async () => {
    return '';
};
exports.getFirebaseUserTokenId = getFirebaseUserTokenId;
